<template>
  <b-nav class="nav-toggled">
    <b-nav-item-dropdown id="dropdown-metas" v-if="ocDropdownList.length > 0" no-caret :text="$t('onlineGoals')" class="toggled" left>
      <template v-for="item in ocDropdownList">
        <DropDownItem 
          v-if="item.route"
          :key=item.item 
          :image=item.image 
          :route="`${item.route}`" 
          :modal="`${item.modal}`"
          :text=item.permission 
          :altTxt=item.tooltip 
          :title=item.tooltip>
        </DropDownItem>
        <DropDownItemModal 
          v-if="item.modal"
          :key=item.item 
          :image=item.image 
          :modal="`${item.modal}`"
          :text=item.permission 
          :altTxt=item.tooltip 
          :title=item.tooltip>
        </DropDownItemModal>
      </template>
    </b-nav-item-dropdown>
  </b-nav>
</template>

<script>
import { mapState } from "vuex";
import DropDownItem from "./DropDownItem.vue"
import DropDownItemModal from "./DropDownItemModal.vue"

export default {
  name: "MetasOnlineDropdown",

  components: { DropDownItem, DropDownItemModal },

  computed: mapState(["user"]),

  data() {
    return {
      ocDropdownList: [],
    }
  },

  methods: {
      LoadPermission(){
      let i = 0;
      for (let key in this.user.Permissions){
        if(key.match(/\bmetaonline\d+\b/) && this.user.Permissions[key].allowed)
        {
          let obj = {};
          obj = this.user.Permissions[key]
          obj.item = key
          obj.image = "aceitarplanejamento.png"
          obj.route = `/productionmonitoring/${obj.parameter}`
          obj.index = 100 + i++
          this.ocDropdownList.push(obj)
        }        
      }

      this.ocDropdownList.sort((a, b) => a.index > b.index ? 1 : a.index < b.index ? -1 : 0)
      
    }
  },
  created() {
    this.LoadPermission()
  }
};
</script>

<style scoped>
img.Item {
  max-height: 37px;
  max-width: 37px;
  border-radius: 5px;
  margin: auto;
}

img.dropItem {
  max-height: 25px;
  max-width: 25px;
  border-radius: 5px;
  margin-right: 10px;
}

.ilink {
  margin-right: 10px;
}

</style>
